var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_960",
    "data-name": "Group 960",
    transform: "translate(-404 -6311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_129",
    "data-name": "Ellipse 129",
    transform: "translate(404 6311)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.85,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "track_13794484",
    d: "M18.749,11.174a2.74,2.74,0,0,0,3.81,0l1.938-1.9a5.435,5.435,0,1,0-7.678.009l1.93,1.887ZM22.286,5.2a1.631,1.631,0,1,1-1.631-1.631A1.631,1.631,0,0,1,22.286,5.2ZM4.348,23.915a2.174,2.174,0,1,1-2.174-2.174A2.174,2.174,0,0,1,4.348,23.915Zm11.414-6.522a2.174,2.174,0,1,1-2.174-2.174A2.174,2.174,0,0,1,15.762,17.393ZM2.174,14.132A4.353,4.353,0,0,1,6.522,9.784h7.609a1.087,1.087,0,1,1,0,2.174H6.522a2.174,2.174,0,1,0,0,4.348H8.7a1.087,1.087,0,1,1,0,2.174H6.522A4.353,4.353,0,0,1,2.174,14.132ZM26.09,20.654A4.353,4.353,0,0,1,21.741,25H7.609a1.087,1.087,0,1,1,0-2.174H21.741a2.174,2.174,0,1,0,0-4.348H18.48a1.087,1.087,0,0,1,0-2.174h3.261A4.353,4.353,0,0,1,26.09,20.654Z",
    transform: "translate(419 6326.91)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack);
export default __webpack_public_path__ + "static/media/track.dc97490e2e8f22f7ad67dba639bb1c07.svg";
export { ForwardRef as ReactComponent };